import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3072_85188)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0022 15.7461L16.0529 15.695C17.2818 14.4576 19.2812 14.4507 20.5186 15.6797C21.756 16.9086 21.7629 18.908 20.534 20.1454L20.1719 20.51C20.1719 20.51 15.5723 25.1414 7.25028 16.8764C-1.07171 8.61152 3.5279 3.98016 3.5279 3.98016L3.89001 3.61555C5.11893 2.37813 7.1183 2.37125 8.35571 3.60018C9.59313 4.82911 9.60001 6.82847 8.37108 8.06589L8.32391 8.11339C8.11433 8.32441 7.87981 8.51286 7.69859 8.74868C7.17067 9.43561 6.44268 11.2606 9.64072 14.4726C12.8555 17.7014 14.6949 16.9153 15.3799 16.3703C15.61 16.1872 15.795 15.9548 16.0022 15.7461Z",
  stroke: "black",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3072_85188"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export { IconPhone };